









































































































































































































import { Component, Watch } from 'vue-property-decorator';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import { Funcionalidades } from '@/config/funcionalidades';
import { PermisoAccion } from '@/views/base/VariablesPermisos';
import { actionsEvent } from '@/setup';

import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';
import Confirmation from '@/components/Confirmation.vue';

import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import { checkboxColumnDef } from '@/reusable/Grid/aggridColumnDefUtils';

import {
  ParamsApi,
  ClearParam,
  MsgParam,
  IdParams,
  DataApi,
  FilterApi,
} from './models/BajasComerciales.model';

import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  ICellRendererParams,
  ColDef,
  ColumnApi,
  CellClickedEvent,
  ColDefUtil,
} from 'ag-grid-community';

import { fetchBajasComerciales } from './fetchBajasComerciales';
import PopUpGeneratedReports from './PopUpGeneratedReports.vue';
import { getUserId } from '../MantenedorLocalidad/helpers/getUserId';
import BajasComercialesModalVerDetalle from './BajasComercialesModalVerDetalle.vue';
import BajasComercialesAsignarTramo from './BajasComercialesAsignarTramo.vue';

@Component({
  components: {
    FormFieldsContainer,
    DatePicker,
    Confirmation,
    MantenedorGridSinCodigo,
    PopUpGeneratedReports,
    BajasComercialesModalVerDetalle,
    BajasComercialesAsignarTramo,
  },
})
export default class BajasComercialesBase extends ComponenteBase {
  readonly funcionalidad: Funcionalidades = Funcionalidades.BajasComerciales;

  verDetalle: PermisoAccion = {
    accionCodigo: 4,
    visible: false,
  };

  editar: PermisoAccion = {
    accionCodigo: 3,
    visible: false,
  };
  readonly accionesTotales: PermisoAccion[] = [this.verDetalle, this.editar];

  columnApi: any = null;
  gridOptions: GridOptions = null;
  gridEvent: any = null;
  gridApi: GridApi = null;
  columnDefs: ColDef[] = [];
  serverSide: any = null;
  hash_paginacion: any = '';
  total_registros: any = '';

  dialogPopUp: boolean = false;
  activateChangeFn: boolean = false;
  showModalViewDetail: boolean = false;
  showPopUpReport: boolean = false;
  showModalEdit: boolean = false;
  bajaFinalizada: boolean = false;
  dialogAsignarTramo: boolean = false;

  now: string = moment().format('YYYY-MM-DD');
  msgReport: string = '';

  numConfirmations: number = 0;

  confirmationData: Record<string, string> = {
    atenumero: '',
    ateestado: '',
    title: '',
    msgConfirmation: '',
  };

  data: DataApi = {};
  dataList: any = [];
  dataListSelected: any = [];
  filterApi: FilterApi = {};
  initialState: ParamsApi = {
    start_date: moment().subtract(1, 'month'),
    end_date: moment(),
    rut: '',
    configid: '',
    motivo_baja: '',
    tipo_tramo: '',
    razon_estado: '',
    estado_crm: '',
    situacion_baja: '',
    nombre_baja: '',
  };
  objParam: ParamsApi = { ...this.initialState };
  objParamCopy: ParamsApi = { ...this.initialState };
  timeout: { timeout: number } = { timeout: 3000 };

  actions() {
    actionsEvent.onVerDetalle(this.handleViewDetail);
    actionsEvent.onEditar(this.handleViewEdit);
  }

  constructor() {
    super();
    // Remover las acciones para evitar bucles de notificacione
    actionsEvent.removeListeners();
    // Volver a llamar las acciones
    this.actions();

    this.columnDefs = this.colsGrid();

    this.gridOptions = {
      columnDefs: this.columnDefs,
      pagination: true,
      paginationPageSize: 25,
      cacheBlockSize: 25,
      overlayNoRowsTemplate: 'No hay filas para mostrar',
      onGridReady: this.handleMainGridReady,
    };
  }

  colsGrid(): ColDef[] {
    const cols = [
      { field: 'Nombre Baja', id: 'nombre_baja', width: 200 },
      { field: 'Cliente', id: 'cliente', width: 200 },
      { field: 'Fecha Creación', id: 'fecha_alta', width: 180 },
      { field: 'Equipos', id: 'cantidad_equipos', width: 140 },
      { field: 'Perifericos', id: 'cantidad_perifericos', width: 140 },
      { field: 'Total', id: 'total', width: 140 },
      { field: 'Tramo Baja', id: 'tramo_baja_comercial', width: 150 },
      { field: 'Razón Estado CRM', id: 'razon_estado', width: 150 },
      { field: 'Estado CRM', id: 'estado_crm', width: 150 },
      { field: 'Estado Conecta', id: 'estado_conecta', width: 150 },
      { field: 'Situciación Baja', id: 'nombre_situcion_baja', width: 150 },
      { field: 'Motivo de Baja', id: 'motiname', width: 150 },
      { field: 'Tipo de Baja', id: 'nombre_tipo_baja', width: 150 },
      { field: 'Plataforma', id: 'plataforma', width: 150 },
      { field: 'Motivo de Anulación', id: 'motivo_anula', width: 150 },
      {
        field: 'Descripción Anulación',
        id: 'descripcion_anulacion',
        width: 150,
      },
      { field: 'Fecha Fin Definitiva', id: 'fecha_fin_definitiva', width: 180 },
      { field: 'Nota de Venta', id: 'nombre_nota_venta', width: 150 },
      { field: 'Glosa CRM', id: 'glosa_api_crm', width: 150 },
      { field: 'Area Responsable', id: 'area_responsable', width: 150 },
      { field: 'Propietario', id: 'propietario', width: 150 },
      { field: 'Ejecutivo', id: 'ejecutivo', width: 150 },
      { field: 'Mandante', id: 'mandante', width: 151 },
      { field: 'Observaciones', id: 'observaciones', width: 150 },
    ];

    return cols.map(col => {
      let cellRenderer = null;
      if (col.id === 'estado_conecta') {
        cellRenderer = {
          cellRenderer: (params: any) =>
            this.iconState({ state: params.data.estado_conecta }),
        };
      }

      return {
        headerName: col.field,
        field: col.id,
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: col.width,
        minWidth: 100,
        ...cellRenderer,
      };
    });
  }

  iconState({ state }: IdParams): string {
    return `<i class="material-icons" style="width: 15px; height: 15px;margin-top: 7px; border-radius: 50%; background: ${
      state === 'Finalizado' ? 'rgb(42 255 78)' : 'rgb(255 58 58)'
    }"></i>
        <a style="color: #4f4f4f; position: absolute; margin-top: 0%; margin-left: 3%">${state ||
          'Pendiente'}</a>`;
  }

  async handleMainGridReady(event: GridReadyEvent): Promise<void> {
    this.filterApi = await this.getFilters();
    this.gridApi = event.api;
    this.columnApi = event.columnApi;
    this.gridEvent = event;
    const self = this;
    this.getBajasComerciales();
    /*this.serverSide = {
      async getRows(params: any): Promise<void> {
        params.request.paginationSize = self.gridOptions.cacheBlockSize;
        const objectApi = {
          ...self.objParam,
          ...params.request,
          hash_paginacion: self.hash_paginacion,
          total_registros: self.total_registros,
        };
        self.loadingService.showLoading();

        await fetchBajasComerciales({ body: { ...objectApi } })
          .then(resp => {
            const {
              CODIGO_RESPUESTA,
              MENSAJE_RESPUESTA,
              LISTA,
              TOTAL,
            } = resp.data;
            const cod = Number(CODIGO_RESPUESTA);
            if (cod !== 1 || MENSAJE_RESPUESTA) {
              self.dataList = [];
              params.successCallback([{}], 0);
              self.gridApi.showNoRowsOverlay();
              throw new Error(MENSAJE_RESPUESTA);
            }
            self.hash_paginacion = resp.data.hash_paginacion;
            self.total_registros = resp.data.TOTAL;
            params.successCallback(LISTA, TOTAL);
            self.dataList = [...LISTA];
          })
          .catch((err: Error) => {
            if (
              err instanceof Error &&
              err.message &&
              err.message !== 'Network Error'
            ) {
              self.$snotify.error(err.message, { ...self.timeout });
              return;
            }
            self.$snotify.error(
              'Ha ocurrido un error inesperado, por favor intente más tarde',
              { ...self.timeout }
            );
          })
          .finally(() => {
            self.loadingService.hideLoading();
            self.obscheck();
          });
          
      },
    };*/
    this.reloadGrid({});
  }

  async getBajasComerciales() {
    let self = this;
    const objectApi = {
      ...this.objParam,
    };
    self.loadingService.showLoading();
    await fetchBajasComerciales({ body: { ...objectApi } })
      .then(resp => {
        const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA, LISTA, TOTAL } = resp.data;
        const cod = Number(CODIGO_RESPUESTA);
        if (cod !== 1) {
          self.dataList = [];
          self.gridApi.setRowData([]);
          self.gridApi.setDomLayout('autoHeight');
          self.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3000 });
        } else {
          self.gridApi.setRowData(LISTA);
          self.gridApi.setDomLayout('autoHeight');
          self.dataList = [...LISTA];
        }
      })
      .catch((err: Error) => {
        if (
          err instanceof Error &&
          err.message &&
          err.message !== 'Network Error'
        ) {
          self.$snotify.error(err.message, { ...self.timeout });
          return;
        }
        self.$snotify.error(
          'Ha ocurrido un error inesperado, por favor intente más tarde',
          { ...self.timeout }
        );
      })
      .finally(() => {
        self.loadingService.hideLoading();
        //self.obscheck();
      });
  }

  async reloadGrid({ clear = false }: ClearParam): Promise<void> {
    clear && this.clear();
    //setTimeout(() => {
    //  this.gridApi.setServerSideDatasource(this.serverSide);
    //  this.gridApi.setDomLayout('autoHeight');
    //}, 0);
    this.getBajasComerciales();
  }

  handleShowPopUp(confirmation: boolean): void {
    if (!confirmation) return this.clearDataPopUp();
    this.numConfirmations++;
    this.validateSatateValue({
      numConfirmations: this.numConfirmations,
      atenumero: this.confirmationData.atenumero,
      ateestado: this.confirmationData.ateestado,
    });
  }

  validateSatateValue({
    numConfirmations,
    atenumero,
    ateestado,
  }: IdParams): void {
    if (ateestado.toLowerCase() != 'anulado') {
      if (numConfirmations === 1) {
        this.dialogPopUp = false;
        this.confirmationData.title = `Anular Atención Nro ${atenumero}`;
        this.confirmationData.msgConfirmation = `¿Está seguro que desea anular la atención Nro ${atenumero}?`;
        setTimeout(() => (this.dialogPopUp = true), 800);
        return;
      }
      if (numConfirmations === 2) {
        this.clearDataPopUp();
        return;
      }
    }
    this.$snotify.error(
      `La Nota de venta Nro ${atenumero} ya se encuentra anulada`,
      { ...this.timeout }
    );
    this.clearDataPopUp();
  }

  handleFilters(): void {
    this.activateChangeFn && this.reloadGrid({});
  }

  handleSearchFilter(): void {
    this.hash_paginacion = '';
    this.total_registros = '';
    this.activateChangeFn = true;
    //this.reloadGrid({});
    this.getBajasComerciales();
  }

  handleViewDetail({ data }: { data: DataApi }) {
    this.data = data;
    this.showModalViewDetail = true;
    this.showModalEdit = false;
  }

  handleViewEdit(params: any) {
    if (params.data.estado_conecta === 'Finalizado') {
      this.$snotify.warning(
        `La baja ${params.data.nombre_baja} se encuentra finalizada y no se puede editar`,
        { timeout: 10000 }
      );
      this.bajaFinalizada = true;
    } else {
      this.bajaFinalizada = false;
    }
    this.data = params.data;
    this.showModalEdit = true;
    this.showModalViewDetail = true;
  }

  handleCancel(params: any) {
    const { atenumero, ateestado } = params.data;
    this.confirmationData = {
      atenumero,
      ateestado,
      title: `Confirmación PLataforma INET`,
      msgConfirmation: `¿Confirma que la atención Nro ${atenumero} ya fue anulada en la plataforma INET?`,
    };
    this.dialogPopUp = true;
  }

  handleClickAsignarTramo() {
    if (this.dataList.length == 0) {
      this.$snotify.error('No hay datos para mostrar');
      return;
    }
    this.dataListSelected = this.gridApi.getSelectedRows();
    if (this.dataListSelected.length == 0) {
      this.$snotify.error('No ha seleccionados bajas para asignar tramo');
      return;
    }
    this.objParamCopy = { ...this.objParam };
    this.dialogAsignarTramo = true;
  }

  handleClosedModal() {
    this.showModalViewDetail = false;
    this.showModalEdit = false;
    this.dialogAsignarTramo = false;
    this.objParamCopy = { ...this.initialState };
    this.data = {};
    this.dataListSelected = [];
    this.handleSearchFilter();
  }

  handleCloseReport(): void {
    this.showPopUpReport = false;
    this.msgReport = '';
  }

  clear(): void {
    this.objParam = { ...this.initialState };
    this.activateChangeFn = false;
  }

  clearDataPopUp(): void {
    this.dialogPopUp = false;
    this.numConfirmations = 0;
    Object.keys(this.confirmationData).forEach(
      key => (this.confirmationData[key] = '')
    );
  }

  @Watch('objParam.start_date')
  startDateChange() {
    if (this.objParam.start_date > this.objParam.end_date) {
      this.objParam.end_date = this.objParam.start_date;
    }
  }

  @Watch('objParam.end_date')
  endDateChange() {
    if (this.objParam.end_date < this.objParam.start_date) {
      this.objParam.start_date = this.objParam.end_date;
    }
  }

  async getFilters(): Promise<FilterApi> {
    this.loadingService.showLoading();
    const self = this;
    return await fetchBajasComerciales({ endpoint: 'get_filters' })
      .then(response => {
        const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA, FILTER } = response.data;
        if (CODIGO_RESPUESTA != '1' || MENSAJE_RESPUESTA) {
          throw new Error(MENSAJE_RESPUESTA);
        }
        return FILTER;
      })
      .catch((err: Error) => {
        if (err instanceof Error && err.message) {
          self.$snotify.error(err.message, { ...self.timeout });
        } else {
          self.$snotify.error(
            'Ha ocurrido un error inesperado, por favor intente más tarde',
            { ...self.timeout }
          );
        }
      })
      .finally(() => self.loadingService.hideLoading());
  }

  searchFilter({ list, id, propName }: any) {
    const obj = list.find(
      (x: any) => x[id] === this.objParam[id as keyof ParamsApi]
    );
    return obj ? obj[propName] : '';
  }

  async getCSV(tipo: string): Promise<void> {
    const userId = getUserId();
    const user = localStorage.getItem('clienteDefecto');
    const filter: Record<string, string> = {};

    const findItem: Record<string, any[]> = {
      cliente: [this.filterApi.clientes, 'rut', 'cliente'],
      estado: [this.filterApi.estados, 'configid', 'configvalor'],
      motivo: [this.filterApi.motivos, 'motiid', 'motiname'],
    };

    for (const category in findItem) {
      const [list, id, propName] = findItem[category];
      filter[category] = this.searchFilter({
        list,
        id,
        propName,
      });
    }

    this.loadingService.showLoading();

    const self: this = this;

    return await fetchBajasComerciales({
      endpoint: 'export_excel',
      body: {
        userId,
        user,
        tipo: tipo,
        ...self.objParam,
        ...filter,
      },
    })
      .then(resp => {
        const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA } = resp.data;
        if (CODIGO_RESPUESTA != '1') {
          throw new Error(MENSAJE_RESPUESTA);
        }
        self.msgReport = MENSAJE_RESPUESTA;
        self.showPopUpReport = true;
      })
      .catch((err: Error) => {
        if (err instanceof Error && err.message) {
          self.$snotify.error(err.message, { ...self.timeout });
        } else {
          self.$snotify.error(
            'Ha ocurrido un error inesperado, por favor intente más tarde',
            { ...self.timeout }
          );
        }
      })
      .finally(() => self.loadingService.hideLoading());
  }
}
